<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :isSearch="isSearch"
              :tableData="tableData"
              @pageNumChange="pageNumChange"
              @add="addMerchants">
      <div slot="table">
        <activity-table :tableData="tableData.list"></activity-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import ActivityTable from "./ActivityTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getActivityList,newVue} from "../../network/activity";

  export default {
    name: "activityList",
    components: {ActivityTable, MyTable},
    data(){
      return {
        title: "营销商户列表",
        isAdd: true,
        isSearch:false,
        tableData:{},
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/activity/list";
      this.common.HeaderLocationTwo.name = "营销俱乐部管理"
      this.common.HeaderLocationThree.name = "活动列表"
      getActivityList().then(res => {
        this.tableData = res.data;
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      searchEasy(searchItems,pageNum){
        getActivityList(pageNum).then(res => {
          this.tableData = res.data
        })
      },
      addMerchants(){
        this.$router.push("insert/")
      }
    }
  }
</script>

<style scoped>

</style>
